import { EventEmitter } from "ltx/lib/Parser";

export default class Storage extends EventEmitter{
   constructor(key) {
		super();
		this._key = key;
		this._storage = localStorage.getItem(this._key) || null;
	}

   save() {
		this.emit('onChange', this._storage);
		localStorage.setItem(this._key, this._storage);
	}

	remove() {
		this.emit('onRemove');
		localStorage.removeItem(this._key);
	}
}